import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  clearCache(): void {
    localStorage.clear()
    sessionStorage.clear()
  }
}
